import { render } from "./budget_information_wealths.vue?vue&type=template&id=123c8c12&scoped=true"
import script from "./budget_information_wealths.vue?vue&type=script&lang=js"
export * from "./budget_information_wealths.vue?vue&type=script&lang=js"

import "./budget_information_wealths.vue?vue&type=style&index=0&id=123c8c12&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123c8c12"]])

export default __exports__